import React from 'react';
import { Headline } from '../headline/headline';
import { GapSizeType } from '../../../theme/type/gap-type';
import { BreakpointSizeType } from '../../../theme/type/breakpoints-type';
import { cn, marginBottomClass, marginTopClass } from '../../../utils/tailwind';

interface PageHeadlineInterface {
    title: React.ReactChild | string;
    action?: React.ReactElement;
    before?: React.ReactNode;
    mobileBreakUnder?: BreakpointSizeType;
    gapTop?: GapSizeType;
    gapBottom?: GapSizeType;
}

export const PageHeadline: React.FC<PageHeadlineInterface> = ({
    title,
    action,
    gapBottom,
    gapTop,
    mobileBreakUnder,
    before,
}) => {
    const wrapperBreakpointClass: Record<BreakpointSizeType, string> = {
        xs: 'xs:flex xs:items-center xs:justify-between',
        vs: 'vs:flex vs:items-center vs:justify-between',
        sm: 'sm:flex sm:items-center sm:justify-between',
        md: 'md:flex md:items-center md:justify-between',
        lg: 'lg:flex lg:items-center lg:justify-between',
        vl: 'vl:flex vl:items-center vl:justify-between',
        xl: 'xl:flex xl:items-center xl:justify-between',
        xxl: 'xxl:flex xxl:items-center xxl:justify-between',
        fullhd: 'fullhd:flex fullhd:items-center fullhd:justify-between',
    };

    const actionMobileMarginClass: Record<BreakpointSizeType, string> = {
        xs: 'max-xs:mt-small',
        vs: 'max-vs:mt-small',
        sm: 'max-sm:mt-small',
        md: 'max-md:mt-small',
        lg: 'max-lg:mt-small',
        vl: 'max-vl:mt-small',
        xl: 'max-xl:mt-small',
        xxl: 'max-xxl:mt-small',
        fullhd: 'max-fullhd:mt-small',
    };

    return (
        <div
            className={cn(
                marginBottomClass[gapBottom || 'medium'],
                marginTopClass[gapTop || 'none'],
                mobileBreakUnder ? wrapperBreakpointClass[mobileBreakUnder] : 'flex items-center justify-between',
            )}
        >
            <div className="flex flex-1 flex-col items-start">
                {before && before}
                <Headline level="1" gap="none">
                    {title}
                </Headline>
            </div>
            <div
                className={cn(
                    'flex items-center [&>*]:ml-[0.8rem] sm:[&>*]:ml-[1.6rem] [&>*:first-child]:ml-0',
                    mobileBreakUnder && actionMobileMarginClass[mobileBreakUnder],
                )}
            >
                {action && action}
            </div>
        </div>
    );
};
